<div class="festivals-container">
  <div class="card card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="card-title mb-0">
        <span class="lstick"></span>Festivals
      </h4>
      <a
        href="javascript:void(0);"
        class="btn btn-primary"
        (click)="openModal(editModal, {}, MODAL_TITLE.ADD)"
      >
        + Add Festival
      </a>
    </div>

    <div class="table-responsive mt-4">
      <table class="table table-striped border">
        <thead>
          <tr>
            <th scope="col">Images</th>
            <th scope="col">Name</th>
            <th scope="col">Default</th>
            <th scope="col">Visible</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngIf="!loading && list.length === 0">
            <td colspan="7" class="text-center py-4 text-muted">No festivals found.</td>
          </tr>
          <tr *ngFor="let d of list; trackBy: trackById">
            <td>
              <ng-container *ngIf="getFestivalImages(d) as festivalImgs">
                <div class="d-flex flex-wrap align-items-center gap-1" *ngIf="festivalImgs.length">
                  <ng-container *ngFor="let img of festivalImgs | slice : 0 : LIST_IMAGES_PREVIEW_COUNT; let i = index">
                    <button
                      type="button"
                      class="festival-list-thumb-btn p-0 px-1 border-0 rounded"
                      (click)="openImagePreview(festivalImgs, i, imagePreviewModal)"
                      ngbTooltip="Click to preview"
                      placement="top"
                    >
                      <img
                        [src]="img"
                        alt="Festival"
                        class="festival-list-thumb"
                        loading="lazy"
                        onerror="this.style.display='none'"
                      />
                    </button>
                  </ng-container>
                  <span
                    *ngIf="festivalImgs.length > LIST_IMAGES_PREVIEW_COUNT"
                    class="festival-more-badge"
                    (click)="openImagePreview(festivalImgs, LIST_IMAGES_PREVIEW_COUNT, imagePreviewModal)"
                    ngbTooltip="View all {{ festivalImgs.length }} images"
                    placement="top"
                  >
                    +{{ festivalImgs.length - LIST_IMAGES_PREVIEW_COUNT }} more
                  </span>
                </div>
                <span *ngIf="!festivalImgs.length" class="text-muted">-</span>
              </ng-container>
            </td>
            <td>{{ d.name || "-" }}</td>
            <td>
              <span
                class="badge category-tag rounded-pill"
                [ngClass]="d.isDefault ? 'bg-success' : 'bg-secondary'"
              >
                {{ d.isDefault ? "Yes" : "No" }}
              </span>
            </td>
            <td>
              <span
                class="badge category-tag rounded-pill"
                [ngClass]="d.visible !== false ? 'bg-success' : 'bg-secondary'"
              >
                {{ d.visible !== false ? "Yes" : "No" }}
              </span>
            </td>
            <td>{{ d.startDate | date : "mediumDate" }}</td>
            <td>{{ d.endDate | date : "mediumDate" }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-icon-action mr-1"
                (click)="openModal(viewModal, d, MODAL_TITLE.VIEW)"
                ngbTooltip="View"
                placement="top"
              >
                <i class="fa fa-eye"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-icon-action mr-1"
                (click)="openModal(editModal, d, MODAL_TITLE.EDIT)"
                ngbTooltip="Edit"
                placement="top"
              >
               <i class="fa fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-icon-action"
                (click)="openModal(deleteModal, d, MODAL_TITLE.DELETE)"
                ngbTooltip="Delete"
                placement="top"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="d-flex justify-content-between align-items-center flex-wrap mt-3"
      *ngIf="totalCount > 0"
    >
      <div class="d-flex align-items-center">
        <span class="mr-2">Rows per page:</span>
        <select
          class="form-control form-control-sm w-auto"
          [ngModel]="pageSize"
          (ngModelChange)="pageSize = $event; onPageSizeChange()"
        >
          <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
        </select>
      </div>
      <nav>
        <ngb-pagination
          [collectionSize]="totalCount"
          [page]="page"
          [pageSize]="pageSize"
          (pageChange)="onPageChange($event)"
          [maxSize]="5"
          [rotate]="true"
          [ellipses]="true"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </nav>
    </div>
  </div>
</div>

<!-- Add / Edit Festival Modal -->
<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modelTitle }}</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body festival-modal-body-scroll">
    <form (ngSubmit)="onSubmit(festivalForm)" #festivalForm="ngForm">
      <div class="form-group row">
        <label for="name" class="col-sm-4 col-form-label">Name *</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            [(ngModel)]="detail.name"
            #name="ngModel"
            required
            placeholder="e.g. Holi"
          />
          <div class="invalid-feedback d-block" *ngIf="name.invalid && name.touched">
            Name is required
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Default</label>
        <div class="col-sm-8 d-flex align-items-center">
          <input
            type="checkbox"
            id="isDefault"
            name="isDefault"
            [(ngModel)]="detail.isDefault"
          />
          <label for="isDefault" class="mb-0 ml-2">Set as default festival</label>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Visible</label>
        <div class="col-sm-8 d-flex align-items-center">
          <input
            type="checkbox"
            id="visible"
            name="visible"
            [(ngModel)]="detail.visible"
          />
          <label for="visible" class="mb-0 ml-2">Show festival (visible to users)</label>
        </div>
      </div>

      <div class="form-group row">
        <label for="startDate" class="col-sm-4 col-form-label">Start Date *</label>
        <div class="col-sm-8">
          <input
            type="date"
            class="form-control"
            id="startDate"
            name="startDate"
            [(ngModel)]="detail.startDate"
            #startDate="ngModel"
            required
          />
          <div class="invalid-feedback d-block" *ngIf="startDate.invalid && startDate.touched">
            Start date is required
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="endDate" class="col-sm-4 col-form-label">End Date *</label>
        <div class="col-sm-8">
          <input
            type="date"
            class="form-control"
            id="endDate"
            name="endDate"
            [(ngModel)]="detail.endDate"
            #endDate="ngModel"
            required
          />
          <div class="invalid-feedback d-block" *ngIf="endDate.invalid && endDate.touched">
            End date is required
          </div>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label">Festival Images *</label>
        <div class="col-sm-8">
          <input
            type="file"
            class="form-control-file"
            accept="image/*"
            multiple
            (change)="onFestivalImagesChange($event)"
          />
          <small class="form-text text-muted">
            Min {{ MIN_IMAGES }} image, max {{ MAX_IMAGES }} images. When editing: remove images with &times; or add new with the file input above.
          </small>
          <div class="text-danger mt-1" *ngIf="festivalImagesError">{{ festivalImagesError }}</div>
          <div class="d-flex flex-wrap mt-2" *ngIf="festivalImagePreviews.length > 0">
            <div
              class="position-relative mr-2 mb-2"
              *ngFor="let preview of festivalImagePreviews; let i = index"
            >
              <img
                [src]="preview"
                alt="Preview"
                class="festival-edit-thumb"
              />
              <button
                type="button"
                class="btn btn-sm btn-danger position-absolute festival-thumb-remove"
                (click)="removeFestivalImage(i)"
                aria-label="Remove"
              >
                &times;
              </button>
            </div>
          </div>
          <div
            class="d-flex flex-wrap mt-2"
            *ngIf="modelTitle === MODAL_TITLE.EDIT && detail.festivalImages?.length"
          >
            <div class="position-relative mr-2 mb-2" *ngFor="let img of detail.festivalImages; let i = index">
              <img
                [src]="img"
                alt="Existing"
                class="festival-edit-thumb"
              />
              <button
                type="button"
                class="btn btn-sm btn-danger position-absolute festival-thumb-remove"
                (click)="removeExistingImage(i)"
                aria-label="Remove image"
                title="Remove this image"
              >
                &times;
              </button>
            </div>
            <small class="w-100 text-muted">Existing images — click &times; to remove. Add new with the file input above (max {{ MAX_IMAGES }} total).</small>
          </div>
        </div>
      </div>

      <div class="modal-footer border-top pt-3">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="btn btn-primary">
          {{ modelTitle === MODAL_TITLE.ADD ? "Create" : "Update" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- View Festival Modal -->
<ng-template #viewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">View Festival Details</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="detail">
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">Name</label>
      <div class="col-sm-8 col-form-label">{{ detail.name || "-" }}</div>
    </div>
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">Default</label>
      <div class="col-sm-8 col-form-label">
        <span class="badge category-tag rounded-pill" [ngClass]="detail.isDefault ? 'bg-success' : 'bg-secondary'">
          {{ detail.isDefault ? "Yes" : "No" }}
        </span>
      </div>
    </div>
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">Visible</label>
      <div class="col-sm-8 col-form-label">
        <span class="badge category-tag rounded-pill" [ngClass]="detail.visible !== false ? 'bg-success' : 'bg-secondary'">
          {{ detail.visible !== false ? "Yes" : "No" }}
        </span>
      </div>
    </div>
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">Start Date</label>
      <div class="col-sm-8 col-form-label">{{ detail.startDate ? (detail.startDate | date : "mediumDate") : "-" }}</div>
    </div>
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">End Date</label>
      <div class="col-sm-8 col-form-label">{{ detail.endDate ? (detail.endDate | date : "mediumDate") : "-" }}</div>
    </div>
    <div class="row mb-2" *ngIf="detail.countryObject">
      <label class="col-sm-4 col-form-label font-weight-bold">Country</label>
      <div class="col-sm-8 col-form-label">{{ detail.countryObject.countryName }} ({{ detail.countryObject.iso }})</div>
    </div>
    <div class="row mb-2">
      <label class="col-sm-4 col-form-label font-weight-bold">Images</label>
      <div class="col-sm-8">
        <div class="d-flex flex-wrap gap-2" *ngIf="detail.festivalImages?.length">
          <a
            *ngFor="let img of detail.festivalImages"
            [href]="img"
            target="_blank"
            rel="noopener noreferrer"
            class="festival-view-thumb-wrap p-0 px-1"
          >
            <img [src]="img" alt="Festival" class="festival-view-thumb" loading="lazy" />
          </a>
        </div>
        <span *ngIf="!detail.festivalImages?.length" class="text-muted">No images</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
  </div>
</ng-template>

<!-- Image preview Modal -->
<ng-template #imagePreviewModal let-modal>
  <div class="modal-header py-2">
    <h6 class="modal-title mb-0">Image {{ previewIndex + 1 }} of {{ previewImages.length }}</h6>
    <button type="button" class="close" (click)="closeImagePreview()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body festival-preview-body text-center p-0 position-relative">
    <div class="festival-preview-img-wrap">
      <img
        *ngIf="previewImages[previewIndex]"
        [src]="previewImages[previewIndex]"
        alt="Preview"
        class="festival-preview-img"
      />
    </div>
    <button
      *ngIf="previewImages.length > 1"
      type="button"
      class="btn btn-light btn-sm position-absolute festival-preview-nav festival-preview-prev"
      (click)="prevPreviewImage()"
      aria-label="Previous"
    >
      <i class="fa fa-chevron-left"></i>
    </button>
    <button
      *ngIf="previewImages.length > 1"
      type="button"
      class="btn btn-light btn-sm position-absolute festival-preview-nav festival-preview-next"
      (click)="nextPreviewImage()"
      aria-label="Next"
    >
      <i class="fa fa-chevron-right"></i>
    </button>
  </div>
</ng-template>

<!-- Delete confirmation Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Festival</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete <strong>{{ detail?.name }}</strong>?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
  </div>
</ng-template>
